export const FIXED_IMAGES_UUIDS = [
	'578e73cd-275e-4ea8-ab5b-e7bf471aed2a',
	'a8e33e93-aecc-41aa-85dc-d6639ac55f14',
	'daf7e494-84bb-4da2-92fa-e258522c0276',
	'cd85772c-4e56-4246-84c2-1daf531daf9c',
	'68bbaf94-f311-4a6e-a071-b48dde78a8c8',
	'0bcaa92f-5bb8-4fa9-9a6e-128040d2cbbd',
	'a4a5596e-e01c-4bd6-964f-bf043d30e117',
	'dd7908fa-c605-4acb-9d3a-f526f766b0ce',
	'50b977c0-0838-4b6d-9b42-5d2e647e797a',
	'c5b3e51e-56de-44ae-8ac1-84ad112d95dc',
	'715a9807-4600-4d37-a3ac-015aeb1a3ea1',
	'084d5d17-b95d-4d7b-9c0d-9af1fd3026da',
	'512612fa-c723-458d-b78f-13a28132e518',
	'4408679b-242a-4ded-a964-41837b231f6d',
	'e50532ef-08bd-4b9a-a8f2-ba14db5304a2',
	'113d05a4-d0d6-4448-bb63-94f6a557bed2',
	'843fc83a-f602-4fe6-83bc-6aee46602f60',
	'6ab884f7-8eeb-431e-ba3e-99cc46c9115d',
	'35a81bb6-53a4-4e6f-8d7f-aa2b7d5456dc',
	'609ca1cb-de88-421c-b28a-82d3f3b2a854',
	'e4c4e8fa-507d-4ca2-a829-ff420dce68ce',
	'40dc11ae-4a9e-42d7-9b67-faec6ca8d561',
	'060c7549-24d3-4fe8-a421-8b6c2a507678',
	'2207c137-a376-4251-9f07-f2c949dd74c6',
	'a522a60e-8876-4ad2-a1ee-270f7b5873d1',
	'48e389a8-9082-44a9-9978-ae6011f0a2f1',
	'c0db674d-7020-4423-ad2d-22344c60197a',
	'89500323-7f61-4076-a868-1df2a716670b',
	'd05bc6ad-9555-40e0-9803-fc61ebc60aa6',
	'1ba1abc2-4fb8-4d92-9eb9-f90cba913b96',
	'3b831596-444e-4ce4-a11e-4bb1b4e295a1',
	'9b4a730c-331c-45fd-9bb2-dc82bdb595dc',
	'b1bef7c6-6331-4f4b-bc0e-4969453b655b',
	'b4a06a2b-80e6-43cc-88eb-01e6e4bc87de',
	'a5c7b5bb-a05b-47a9-9e0e-3b91d7f57243'
];

export const FIXED_IMAGES = FIXED_IMAGES_UUIDS.map(uuid => `/api/image/${uuid}`);



// WEBPACK FOOTER //
// ./src/profile/fixedImages.js